import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import constants, { MEDIUM } from '../../../abstracts/constants';

const useStyles = makeStyles({
  root: {
    '&, $span': {
      fontFamily: constants.sourceSansPro,
      fontSize: MEDIUM,
      marginRight: 0,
    },
  },
});

const useStylesForCustomLabel = makeStyles({
  root: {
    '&, $label': {
      marginRight: 0,
    },
  },
});

const StyledFormWithCustomLabel = styled.label<{
  disabled?: boolean;
}>`
  font-family: ${constants.sourceSansPro};
  font-size: ${MEDIUM};
  cursor: ${(props): string => (props.disabled ? 'default' : 'pointer')};
`;

export { useStyles, useStylesForCustomLabel, StyledFormWithCustomLabel };
